/* eslint-disable no-console */
import React from 'react';
import { ConfigProvider } from 'antd';
import esES from 'antd/es/locale/es_ES';
import { createRoot } from 'react-dom/client';
import axios from 'axios';
import App from './App';
import { StateProvider } from './providers/StateProvider';
import reducer, { initialState } from './providers/reducer';
import './styles/bootstrap.css';

axios.defaults.baseURL = process.env.REACT_APP_API_ENDPOINT || 'https://localhost:3000/';

console.log(`                                                                           
                                                                                
                              .%%%%%%%(    #%%%%%%%/                            
                             %%&%#/(%%%%%%%%%%(,*%%%%,                          
                           .%%%#                  *%%%,                         
                           %%%%                    /%%%,                        
                          %%%%                      #%%%                        
                     *##%%%%%.                       %%%%%%#/.                  
                *%%%%%%%%%%%(                        ,%%%%%%%%%%%#              
               &%%%,    (%%%                          %%%%     #%%%             
               (%%%/     ,*                            ,*     .%%%%             
                 %%%%%(                                    /%%%%%,              
                   .#%%%%%%%#,                      ./%%%%%%%%,                 
                        .%&%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%,                      
                         %%%%     ,*/(#####((/*,     /%%%                       
                *#%%%%%%%%%%%.                       %%%%%%%%%%%#/.             
              ,%%%%%%#(/,.%%%%                      #%%%.,*(#%%%%%%(            
                 %%%%&.    #%%%,                   &%%&     %%%%&,              
                   /%%%%(   ,%%%%                %%%%(   *%%%%#                 
              .%%%%%%%%%&%%   /%%%%(          *%%%%#   (%%%%%%%%%%%,            
           #%%%%%%(.    (%%%%   .%%%%%%,  .#%%&%%,   %%%%%     /%%%%%%%.        
         %%%%#            .(.       (%%%%%%%&%        (,            /&%%%.      
        %%%#                                                          (%%%.     
       #%%%                                                            #%%%     
      .%%%/                                                            .%%%*    
      #%%%                                                              #%%%    
     .%%%*   (%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#    %%%/   
     %%%%   %%%%/*************************************************%%&%,  (%%%   
    ,%%%.   %%%*                                                  .%%%,   %%%(  
    %%%%    %%%(                                                  .%%%.   (%%%  
    %%%/    %%%#                                                  *%%%.    %%%, `);
console.log(
    '%c          ¡ALTO!',
    'color:red;font-family:system-ui;font-size:4rem;-webkit-text-stroke: 1px black;font-weight:bold',
);
console.log(`
  
            .%%%,                                                 %%%*          
             %%%*                                                .%%%.          
             %%%(                                                *%%%           
             *%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%#           
            ,%%%%################################################%%%%#          
            *%%%(,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,,/%%%%          
              %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%&.  
                                                                               
`);

console.log('%cSi usas esta consola, es posible que los atacantes roben tu identidad y tu información a través de un ataque de seguridad.No ingreses ni pegues ningún código que no entiendas.', 'color:red;font-family:system-ui;font-size:1rem;-webkit-text-stroke: 1px black;font-weight:bold');

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <StateProvider initialState={initialState} reducer={reducer}>
        <ConfigProvider locale={esES}>
            <App />
        </ConfigProvider>
    </StateProvider>,
);
